import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Switch, Route, Redirect, BrowserRouter as Router, } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import SuperAdminRoute from "./SuperAdminRoute";
import EmployeeRoute from "./EmployeeRoute";
import AdminRoute from "./AdminRoute";
import EmployeeAdminRoute from "./EmployeeAdminRoute";
import SuperAdminTesterRoute from "./SuperAdminTesterRoute";
import LoginPage from "../pages/public-pages/LoginPage";
import ForgotPasswordPage from "../pages/public-pages/ForgotPasswordPage";
import ResetPasswordPage from "../pages/public-pages/ResetPasswordPage";
import DashboardPage from "../pages/dashboard/DashboardPage";
import HierarchyPage from "../pages/hierarchy/HierarchyPage";
import UserCreatePage from "../pages/users/UserCreatePage";
import UsersPage from "../pages/users/UsersPage";
import UserProfilePage from "../pages/users/UserProfilePage";
import UserInfo from "../pages/users/UserInfo";
import UserEditPage from "../pages/users/UserEditPage";
import SkillsPage from "../pages/skills/SkillsPage";
import SkillCreatePage from "../pages/skills/SkillCreatePage";
import SkillEditPage from "../pages/skills/SkillEditPage";
import AreasPage from "../pages/areas/AreasPage";
import AreaCreatePage from "../pages/areas/AreaCreatePage";
import AreaEditPage from "../pages/areas/AreaEditPage";
import PaymentConditionsPage from "../pages/payment-conditions/PaymentConditionsPage";
import PaymentConditionCreatePage from "../pages/payment-conditions/PaymentConditionCreatePage";
import PaymentConditionEditPage from "../pages/payment-conditions/PaymentConditionEditPage";
import PerformancesPage from "../pages/performances/PerformancesPage";
import PerformanceCreatePage from "../pages/performances/PerformanceCreatePage";
import PerformanceEditPage from "../pages/performances/PerformanceEditPage";
import FixedCostsPage from "../pages/fixed-costs/FixedCostsPage";
import FixedCostsCreatePage from "../pages/fixed-costs/FixedCostsCreatePage";
import FixedCostsEditPage from "../pages/fixed-costs/FixedCostsEditPage";
import FixedCostsGroupedPage from "../pages/fixed-costs/FixedCostsGroupedPage";
import LoggedHoursPage from "../pages/logged-hours/LoggedHoursPage";
import MyLogsPage from "../pages/logged-hours/MyLogsPage";
import LogHoursPage from "../pages/tasks/LogHoursPage";
import TaskCreatePage from "../pages/tasks/TaskCreatePage";
import TasksPage from "../pages/tasks/TasksPage";
import TaskEditPage from "../pages/tasks/TaskEditPage";
import MyTasksPage from "../pages/tasks/MyTasksPage";
import TaskLogs from "../pages/tasks/TaskLogs";
import ProjectsPage from "../pages/projects/ProjectsPage";
import ProjectCreatePage from "../pages/projects/ProjectCreatePage";
import ProjectEditPage from "../pages/projects/ProjectEditPage";
import ProjectInfo from "../pages/projects/ProjectInfo";
import ProjectsDetailsPage from "../pages/projects/ProjectsDetailsPage";
import DocumentsPage from "../pages/documents/DocumentsPage";
import DocumentsCreatePage from "../pages/documents/DocumentsCreatePage";
import DocumentsEditPage from "../pages/documents/DocumentsEditPage";
import DaysOffPage from "../pages/days-off/DaysOffPage";
import DayOffCreatePage from "../pages/days-off/DayOffCreatePage";
import DayOffEditPage from "../pages/days-off/DayOffEditPage";
import CalendarPage from "../pages/days-off/CalendarPage";
import DaysOffRequestsPage from "../pages/days-off/DayOffRequestsPage";
import PackagesPage from "../pages/packages/PackagesPage";
import PackageCreatePage from "../pages/packages/PackageCreatePage";
import PackageEditPage from "../pages/packages/PackageEditPage";
import SystemLogsPage from "../pages/system-logs/SystemLogsPage";
import SystemSettingsPage from "../pages/system-settings/SystemSettingsPage";
import BugsPage from "../pages/bugs/BugsPage";
import BugCreatePage from "../pages/bugs/BugCreatePage";
import BugEditPage from "../pages/bugs/BugEditPage";
import NotFound from "../pages/public-pages/NotFound";

const BaseRouter = (props) => (
	<div className="rooter-wrapper">
		<NotificationContainer />
		<Switch>
			{/* Initial route when user enters app */}
			<Route path="/" exact render={() => {
				if (props.isAuthenticated) { return <Redirect to="/dashboard" />; }
				return <Redirect to="/login" />;
			}} />

			{/* Public Routes */}
			<PublicRoute location={props.location} path="/login" exact component={LoginPage} />
			<PublicRoute location={props.location} path="/forgot-password" exact component={ForgotPasswordPage} />
			<PublicRoute location={props.location} path="/reset-password/:email/:token" exact component={ResetPasswordPage} />
			
			{/* Private Routes */}
			<PrivateRoute location={props.location} path="/dashboard" exact component={DashboardPage} />	
			<PrivateRoute location={props.location} path="/hierarchy" exact component={HierarchyPage} />		
			<PrivateRoute  location={props.location} path="/profile" exact component={UserProfilePage} />	

			{/* SuperAdmin Routes */}
			<SuperAdminRoute  location={props.location} path="/skills" exact component={SkillsPage} />
			<SuperAdminRoute  location={props.location} path="/skills/create-skill" exact component={SkillCreatePage} />			
			<SuperAdminRoute  location={props.location} path="/skills/:skillId/edit" exact component={SkillEditPage} />
			<SuperAdminRoute  location={props.location} path="/payment-conditions" exact component={PaymentConditionsPage} />
			<SuperAdminRoute  location={props.location} path="/payment-conditions/create-payment-condition" exact component={PaymentConditionCreatePage} />			
			<SuperAdminRoute  location={props.location} path="/payment-conditions/:paymentId/edit" exact component={PaymentConditionEditPage} />
			<SuperAdminRoute  location={props.location} path="/performances" exact component={PerformancesPage} />
			<SuperAdminRoute  location={props.location} path="/performances/create-performance" exact component={PerformanceCreatePage} />			
			<SuperAdminRoute  location={props.location} path="/performances/:performanceId/edit" exact component={PerformanceEditPage} />
			<SuperAdminRoute  location={props.location} path="/areas" exact component={AreasPage} />
			<SuperAdminRoute  location={props.location} path="/areas/create-area" exact component={AreaCreatePage} />			
			<SuperAdminRoute  location={props.location} path="/areas/:areaId/edit" exact component={AreaEditPage} />
			<SuperAdminRoute location={props.location} path="/fixed-costs" exact component={FixedCostsGroupedPage} />
			<SuperAdminRoute location={props.location} path="/fixed-costs/create-fixed-cost" exact component={FixedCostsCreatePage} />
			<SuperAdminRoute location={props.location} path="/fixed-costs/:fixedCostId/edit" exact component={FixedCostsEditPage} />
			<SuperAdminRoute location={props.location} path="/fixed-costs/:date" exact component={FixedCostsPage} />
			<SuperAdminRoute location={props.location} path="/users/create-user" exact component={UserCreatePage} />
			<SuperAdminRoute location={props.location} path="/users/:userId/edit" exact component={UserEditPage} />
			<SuperAdminRoute location={props.location} path="/system-logs" exact component={SystemLogsPage} />
			<SuperAdminRoute location={props.location} path="/system-settings" exact component={SystemSettingsPage} />
			<SuperAdminRoute location={props.location} path="/days-off/add-day-off" exact component={DayOffCreatePage} />
			<SuperAdminRoute location={props.location} path="/days-off" exact component={DaysOffPage} />
			<SuperAdminRoute location={props.location} path="/projects/info" exact component={ProjectsDetailsPage} />

			{/* Route for superadmin, admin and testers */}
			<SuperAdminTesterRoute location={props.location} path="/bugs" exact component={BugsPage} />
			<SuperAdminTesterRoute location={props.location} path="/bugs/create-bug" exact component={BugCreatePage} />
			<SuperAdminTesterRoute location={props.location} path="/bugs/:bugId/edit" exact component={BugEditPage} />

			{/* Employee and Admin routes only, not for superadmin, because superadmin dont have salary and cant log hours */}
			<EmployeeAdminRoute location={props.location} path="/tasks/my-tasks" exact component={MyTasksPage} />	
			<EmployeeAdminRoute location={props.location} path="/my-logs" exact component={MyLogsPage} />								
			<EmployeeAdminRoute location={props.location} path="/tasks/log-hours" exact component={LogHoursPage} />

			{/* Admin Routes */}
			<AdminRoute location={props.location} path="/packages" exact component={PackagesPage} />
			<AdminRoute location={props.location} path="/packages/create-package" exact component={PackageCreatePage} />
			<AdminRoute location={props.location} path="/packages/:packageId/edit" exact component={PackageEditPage} />
			<AdminRoute location={props.location} path="/projects" exact component={ProjectsPage} />
			<AdminRoute location={props.location} path="/projects/create-project" exact component={ProjectCreatePage} />			
			<AdminRoute location={props.location} path="/projects/:projectId/info" exact component={ProjectInfo} />
			<AdminRoute location={props.location} path="/projects/:projectId/edit" exact component={ProjectEditPage} />	
			<AdminRoute location={props.location} path="/tasks/all-tasks" exact component={TasksPage} />	
			<AdminRoute location={props.location} path="/tasks/create-task" exact component={TaskCreatePage} />	
			<AdminRoute location={props.location} path="/tasks/:taskId/edit" exact component={TaskEditPage} />	
			<AdminRoute location={props.location} path="/days-off/:dayOffId/:typeId/edit" exact component={DayOffEditPage} />
			<AdminRoute location={props.location} path="/documents/create-document" exact component={DocumentsCreatePage} />
			<AdminRoute location={props.location} path="/documents/:documentId/edit" exact component={DocumentsEditPage} />

			{/* Employee Routes */}
			<EmployeeRoute  location={props.location} path="/tasks/:taskId/logs" exact component={TaskLogs} />
			<EmployeeRoute location={props.location} path="/users/:userId" exact component={UserInfo} />		
			<EmployeeRoute location={props.location} path="/users" exact component={UsersPage} />			
			<EmployeeRoute location={props.location} path="/logged-hours" exact component={LoggedHoursPage} />
			<EmployeeRoute location={props.location} path="/days-off/calendar" exact component={CalendarPage} />
			<EmployeeRoute location={props.location} path="/days-off/requests" exact component={DaysOffRequestsPage} />	
			<EmployeeRoute location={props.location} path="/documents" exact component={DocumentsPage} />

			{/* Not Found Route */}
			<Route render={() => <NotFound />} />

		</Switch>
	</div>
);

function mapStateToProps(state) {
	return {
		isAuthenticated: !!(state.userLoginData && state.userLoginData.token),
	};
}

BaseRouter.propTypes = {
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired
	}).isRequired,
	isAuthenticated: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(BaseRouter);


// WEBPACK FOOTER //
// ./src/components/routes/BaseRoute.js